import CommonLink from 'components_v2/CommonLink'
import React, { Fragment } from 'react'

const InstructorList = ({ list = [] }) => {
  const length = list?.length || 0
  return (
    <span className='author-info'>
      {' '}
      {list.map((item, ix) => {
        const fullName = [
          item?.coachInfo?.user?.firstName || item?.firstName,
          item?.coachInfo?.user?.lastName || item?.lastName
        ].join(' ')
        const slug = item?.coachInfo?.slug || item?.slug
        return (
          <Fragment key={slug}>
            {ix > 0 && ix !== length - 1
              ? ', '
              : ix === length - 1 && length > 1
              ? ' & '
              : ''}
            {item?.coachInfo?.softDeleted || item?.softDeleted ? (
              <>{fullName}</>
            ) : (
              <CommonLink className='link' to={`/instructors/${slug}`}>
                {fullName}
              </CommonLink>
            )}
          </Fragment>
        )
      })}
    </span>
  )
}

export default InstructorList
